import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "create-customer-group",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const createCustomerGroup = require("./CreateCustomerGroup").default;
          cb(null, createCustomerGroup);
        },
        "CreateCustomerGroup"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/CustomerGroup/CreateCustomerGroup/index.js